import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';

type DateRangeProps = {
  className?: string;
  startDate: string;
  endDate: string;
  rangeUpdated: (startDate: string, endDate: string) => void;
  dateFormat?: string;
}

const DateRange = (props: DateRangeProps) => {
  const toMydString = (date: Dayjs): string => {
    var dateFormat = props.dateFormat ?? 'YYYY/MM/DD';
    return date.format(dateFormat);
  }

  const updateStartDate = (date: Dayjs | null) => {
    if (!date) return;
    if (dayjs() < date) { date = dayjs() }

    var endDate = dayjs(props.endDate);

    if (endDate && endDate < date) {
      endDate = date;
    }

    props.rangeUpdated(toMydString(date), toMydString(endDate));
  }

  const updateEndDate = (date: Dayjs | null) => {
    if (!date) return;
    if (dayjs() < date) { date = dayjs() }

    var startDate = dayjs(props.startDate);

    if (startDate && date < startDate) {
      startDate = date;
    }

    props.rangeUpdated(toMydString(startDate), toMydString(date))
  }

  return <div className={props.className ?? "row mt-4 mb-2"}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className='col-5'>
        <DatePicker
          label="Start Date"
          className="p-0"
          reduceAnimations={true}
          sx={{ zIndex: 0 }}
          value={dayjs(props.startDate)}
          onChange={(newValue) => updateStartDate(newValue)} />
      </div>
      <div className='col-5'>
        <DatePicker
          label="End Date"
          reduceAnimations={true}
          sx={{ zIndex: 0 }}
          value={dayjs(props.endDate)}
          onChange={(newValue) => updateEndDate(newValue)} />
      </div>
    </LocalizationProvider>
  </div>
}

export default DateRange;